


const pricingSearchFilters = (list:any[], change: (item: any)=> void, defaultValue:any) => {
	//console.log(list)
	const returnArray = [];
	const fixed = list.filter((item:any) => item.price_model.value === 'FIXED').length;
	const section = list.filter((item:any) => item.price_model.value === 'SECTION').length;
	const element = list.filter((item:any) => item.price_model.value === 'ELEMENT').length;
	const size = list.filter((item:any) => item.price_model.value === 'SIZE').length;

	if (fixed > 0) {
		returnArray.push({
			label: 'Fixed',
			onClick: (value: boolean) => {
				change({ price_model: 'fixed', enabled: value });
				console.log('Show Inactive Items:', value);
			},
			default: defaultValue.fixed,
			count: fixed,
		});
	}
	if (section > 0) {
		returnArray.push({
			label: 'Section',
			onClick: (value: boolean) => {
				change({ price_model: 'section', enabled: value });
				console.log('Show Inactive Items:', value);
			},
			default: defaultValue.section,
			count: section,
		});
	}
	if (element > 0) {
		returnArray.push({
			label: 'Element',
			onClick: (value: boolean) => {
				change({ price_model: 'element', enabled: value });
				console.log('Show Inactive Items:', value);
			},
			default: defaultValue.element,
			count: element,
		});
	}
	if (size > 0) {
		returnArray.push({
			label: 'Size',
			onClick: (value: boolean) => {
				change({ price_model: 'size', enabled: value });
				console.log('Show Inactive Items:', value);
			},
			default: defaultValue.size,
			count: size,
		});
	}

	return returnArray;
};


export default pricingSearchFilters;